import React from "react";
import ReactDOM from "react-dom/client";
import Modal from "react-modal";
import { ToastContainer } from "react-toastify";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

import { AuthProvider } from "./modules/Auth";
import { CacheProvider } from "./modules/Cache";
import { msalConfig } from "./authConfig";
import reportWebVitals from "./reportWebVitals";
import App from "./App";

import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

Modal.setAppElement(document.getElementById("root") as HTMLElement);

const msalInstance = new PublicClientApplication(msalConfig);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <CacheProvider>
          <App />
          <ToastContainer
            position="bottom-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            rtl={false}
            pauseOnFocusLoss={false}
            pauseOnHover={false}
            closeOnClick
            draggable
          />
        </CacheProvider>
      </AuthProvider>
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
